import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { pushNotification } from "utils/notifications";
import HoaDonApi from "service/hoaDonApi";
import CauHinhApi from "service/cauHinhApi";
import cauHinh from "utils/cauHinh";

// Viettel mất vài giây mỗi hóa đơn, mỗi request phải xong trước timeout 60s của HAProxy
const SO_PHIEU_MOI_LO = 5;

const cellStyle = {
  border: "1px solid #e3ebf3",
  padding: "4px 6px",
  verticalAlign: "middle",
};

export const ModalXuatHoaDonNhieu = ({
  show,
  onHide,
  items,
  isBanNhap = false,
  onSuccess,
}) => {
  const [rows, setRows] = useState(() =>
    items.map((item) => ({
      ...item,
      MaSoThue: "",
      KetQua: "",
      ThongBao: "",
    })),
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tyLePhiXuat, setTyLePhiXuat] = useState(0);

  useEffect(() => {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200 && response.data.length > 0) {
        const cfgTyLe = response.data.find(
          (e) => e.keyConfig.toUpperCase() === cauHinh.sKey.TyLePhiXuat.toUpperCase(),
        );
        if (cfgTyLe) setTyLePhiXuat(parseFloat(String(cfgTyLe.valueConfig).replace(",", ".")) || 0);
      }
    }).catch(() => {});
  }, []);

  const tienPhiGoc = (row) => (row.OtheFeeHangKy || 0) + (row.OtherFee || 0);
  const tienPhiThucTe = (row) =>
    tyLePhiXuat > 0 ? Math.round(tienPhiGoc(row) * tyLePhiXuat) : tienPhiGoc(row);

  const updateRow = (thuChiId, changes) =>
    setRows((prev) =>
      prev.map((r) => (r.ThuChiID === thuChiId ? { ...r, ...changes } : r)),
    );

  const capNhatKetQua = (ketQua) =>
    setRows((prev) =>
      prev.map((r) => (ketQua[r.ThuChiID] ? { ...r, ...ketQua[r.ThuChiID] } : r)),
    );

  const daChay = rows.some((r) => r.KetQua);
  const soThanhCong = rows.filter((r) => r.KetQua === "ok").length;
  const soLoi = rows.filter((r) => r.KetQua === "loi").length;
  const conLai = rows.filter((r) => r.KetQua !== "ok");

  const handleClose = () => {
    if (!isSubmitting) onHide();
  };

  const onSubmit = async () => {
    setIsSubmitting(true);
    let thanhCong = 0;
    for (let i = 0; i < conLai.length; i += SO_PHIEU_MOI_LO) {
      const lo = conLai.slice(i, i + SO_PHIEU_MOI_LO);
      const dangXuat = {};
      lo.forEach((r) => {
        dangXuat[r.ThuChiID] = { KetQua: "dang", ThongBao: "" };
      });
      capNhatKetQua(dangXuat);

      const response = await HoaDonApi.xuatNhieuHoaDon(
        lo.map((r) => ({
          ThuChiId: r.ThuChiID,
          TienLai: r.ValueLai || 0,
          TienPhi: tienPhiThucTe(r),
          MaSoThue: r.MaSoThue,
        })),
        isBanNhap,
      );
      const results = (response.ok && response.data && response.data.Results) || [];
      const loiChung = response.ok
        ? "Không nhận được kết quả xuất hóa đơn"
        : (response.data && response.data.Message) || "Lỗi khi xuất hóa đơn";

      const ketQua = {};
      for (const r of lo) {
        const kq = results.find((x) => x.ThuChiId === r.ThuChiID);
        if (kq && kq.Success) {
          thanhCong++;
          ketQua[r.ThuChiID] = {
            KetQua: "ok",
            ThongBao: kq.SoHoaDon ? `Số HĐ: ${kq.SoHoaDon}` : "",
          };
        } else {
          ketQua[r.ThuChiID] = {
            KetQua: "loi",
            ThongBao: (kq && kq.Message) || loiChung,
          };
        }
      }
      capNhatKetQua(ketQua);
    }
    setIsSubmitting(false);

    const loai = isBanNhap ? "bản nháp" : "hóa đơn";
    pushNotification(
      thanhCong === conLai.length
        ? `Xuất ${loai} thành công ${thanhCong} thu chi`
        : `Xuất ${loai} thành công ${thanhCong}/${conLai.length} thu chi`,
      thanhCong === conLai.length ? "success" : "warning",
      "TOP_CENTER",
      3000,
    );
    if (thanhCong > 0) onSuccess && onSuccess();
  };

  const renderKetQua = (row) => {
    if (row.KetQua === "dang") return <span className="color7">Đang xuất...</span>;
    if (row.KetQua === "ok")
      return <span className="color-xanh-bold">Thành công {row.ThongBao}</span>;
    if (row.KetQua === "loi") return <span className="color-do-bold">{row.ThongBao}</span>;
    return <span className="color7">Chờ xuất</span>;
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold">
          <span className="btn-icon-right">
            <i className="mdi mdi-file-document-outline"></i>
          </span>
          {isBanNhap ? "Xuất bản nháp" : "Xuất hóa đơn"} ({rows.length} thu chi)
        </h4>
        <button type="button" className="close-popup-new" onClick={handleClose}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>

      <Modal.Body>
        <div className="form form-horizontal">
          <div className="form-body">
            {tyLePhiXuat > 0 && (
              <div className="form-group row">
                <label className="col-md-3 label-control color7-bold">
                  Tỷ lệ phí xuất
                </label>
                <div className="col-md-3 d-flex align-items-center">
                  <span className="color7">{tyLePhiXuat}</span>
                </div>
              </div>
            )}

            <div style={{ overflowX: "auto", maxHeight: "60vh" }}>
              <table style={{ borderCollapse: "collapse", width: "100%", minWidth: "760px" }}>
                <thead>
                  <tr className="color7-bold">
                    <th style={{ ...cellStyle, textAlign: "center" }}>STT</th>
                    <th style={{ ...cellStyle, textAlign: "center" }}>Thời gian</th>
                    <th style={cellStyle}>Tên khách hàng</th>
                    <th style={{ ...cellStyle, textAlign: "right" }}>Tiền lãi</th>
                    <th style={{ ...cellStyle, textAlign: "right" }}>
                      {tyLePhiXuat > 0
                        ? "Tiền các loại phí (bao gồm tỷ lệ phí xuất)"
                        : "Tiền các loại phí"}
                    </th>
                    <th style={cellStyle}>Mã số thuế</th>
                    <th style={cellStyle}>Kết quả</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={row.ThuChiID}>
                      <td style={{ ...cellStyle, textAlign: "center" }} className="color7">
                        {index + 1}
                      </td>
                      <td style={{ ...cellStyle, textAlign: "center" }} className="color7">
                        {getDate(row.Time)}
                      </td>
                      <td style={cellStyle} className="color7">
                        {row.nameCus}
                      </td>
                      <td style={{ ...cellStyle, textAlign: "right" }} className="color-xanh-bold">
                        {formatNumber(row.ValueLai || 0)}
                      </td>
                      <td style={{ ...cellStyle, textAlign: "right" }} className="color-do-bold">
                        {formatNumber(tienPhiThucTe(row))}
                      </td>
                      <td style={{ ...cellStyle, width: "160px" }}>
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Mã số thuế..."
                          value={row.MaSoThue}
                          onChange={(e) =>
                            updateRow(row.ThuChiID, { MaSoThue: e.target.value })
                          }
                          disabled={isSubmitting || row.KetQua === "ok"}
                        />
                      </td>
                      <td style={cellStyle}>{renderKetQua(row)}</td>
                    </tr>
                  ))}
                  <tr className="color7-bold">
                    <td style={{ ...cellStyle, textAlign: "center" }} colSpan="3">
                      Tổng
                    </td>
                    <td style={{ ...cellStyle, textAlign: "right" }} className="color-xanh-bold">
                      {formatNumber(rows.reduce((s, r) => s + (r.ValueLai || 0), 0))}
                    </td>
                    <td style={{ ...cellStyle, textAlign: "right" }} className="color-do-bold">
                      {formatNumber(rows.reduce((s, r) => s + tienPhiThucTe(r), 0))}
                    </td>
                    <td style={cellStyle} colSpan="2">
                      {daChay && !isSubmitting && (
                        <span className="color7">
                          Thành công {soThanhCong}/{rows.length}
                          {soLoi > 0 ? `, lỗi ${soLoi}` : ""}
                        </span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        {conLai.length > 0 && (
          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>
            {isSubmitting
              ? "Đang xử lý..."
              : soLoi > 0
                ? `Xuất lại ${soLoi} thu chi lỗi`
                : "Xác nhận"}
          </button>
        )}
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={handleClose}
          disabled={isSubmitting}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
